export default __webpack_public_path__ + "static/media/kitchen3-before1.9d85a018.jpg";